<template>
	<div class="layout">
		<div class='head'>
			<div class="uni-row head-1">
				<div class="flex-item-20" @click="getReconciliationList('昨日')"
					:style="{'border-bottom':currentDate == '昨日' ? '3px solid #ff6a7f':'none'}">昨日</div>
				<div class="flex-item-20" @click="getReconciliationList('本周')"
					:style="{'border-bottom':currentDate == '本周' ? '3px solid #ff6a7f':'none'}">本周</div>
				<div class="flex-item-20" @click="getReconciliationList('本月')"
					:style="{'border-bottom':currentDate == '本月' ? '3px solid #ff6a7f':'none'}">本月</div>
				<div class="flex-item-20" @click="getReconciliationList('本年')"
					:style="{'border-bottom':currentDate == '本年' ? '3px solid #ff6a7f':'none'}">本年</div>
				<div class="flex-item-20" @click="getReconciliationList('自定义')"
					:style="{'border-bottom':currentDate == '自定义' ? '3px solid #ff6a7f':'none'}">
					<DatePicker :open="pickerStatus" confirm type="daterange" @on-change="pickerChange"
						@on-clear="pickerClear" @on-ok="pickerOk" :transfer='true'>
						自定义
					</DatePicker>
				</div>
			</div>
			<div class="uni-row head-2">
				<div class="head-2-left">
					期初结存：¥{{balanceAmount}}
				</div>
				<div class="head-2-center">
					<Select v-model="searchItems.customerId" filterable clearable @on-change="selectChange">
						<Option v-for="item in customerList" placeholder="请选择客户" :value="item.id" :key="item.id">
							{{item.name}}
						</Option>
					</Select>
				</div>
				<div class="head-2-right">
					期末合计：¥{{finalTotal}}
				</div>
			</div>
		</div>
		<div class="body">
			<Table row-key="guid" ref="customerReconciliationList" :columns="tableColumns" :data="itemData">
			</Table>
		</div>
		<div id="voucher-bottomBar">
			<table style="float: left;">
				<tr>
					<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
						<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">新增合计：</span>
						<span style="color: #ff4d4d;font-size: 22px;">￥{{totalAmount}}</span>
					</td>
					<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
						<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">收回合计：</span>
						<span style="color: #ff4d4d;font-size: 22px;">￥{{balanceAmount}}</span>
					</td>
					<td>
						<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">折扣合计：</span>
						<span style="color: #ff4d4d;font-size: 22px;">￥{{totalDiscount}}</span>
					</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'

	export default {
		name: 'constomerreconciliationlist',
		components: {},
		data() {
			return {
				themeBgColor: '#ff6a7f',
				currentDate: '昨日',
				searchItems: {
					totalBusinessDate: [
						dateUtil.startTime(dateUtil.getYesterday()),
						dateUtil.endTime(dateUtil.getYesterday())
					],
					customerId: 0
				},
				tableColumns: [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '单据编号',
						key: 'listCode',
						render: (h, params) => {
							return h('a', {
								class: 'jxyd-a',
								on: {
									click: (e) => {
										this.goList(params.row);
									}
								}
							}, " " + params.row.listCode)
						}
					},
					{
						title: '单据类型',
						key: 'listType',
						render: (h, params) => {
							return h('Tag', {
								style: {},
								attrs: {
									color: 'red'
								}
							}, params.row.listType);
						}
					},
					{
						title: '业务日期',
						key: 'businessDate',
						render: (h, params) => {
							return h('span', {}, formatDate(new Date(params.row.businessDate), 'yyyy-MM-dd'));
						}
					},
					{
						title: '新增金额',
						key: 'amount'
					},
					{
						title: '收回金额',
						key: 'paymentAmount'
					},
					{
						title: '欠款金额',
						key: 'unpaidAmount'
					},
					{
						title: '期末金额',
						key: 'originalPrice'
					}
				],
				pickerStatus: false,
				paymentTotal: 0,
				unpaidTotal: 0,
				totalDiscount: 0,
				totalAmount: 0,
				customerList: [],
				itemData: [],
				balanceAmount: 0,
				finalTotal: 0,
				permission: {
					isShow: true
				}
			}
		},

		methods: {
			initItemData() {
				if(!this.permission.isShow){
					return
				}
				let self = this
				request.post('/api/ReconciliationList/GetCustomerReconciliationList', this.searchItems).then(function(
					result) {
					if (result.state != 1) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取对账单失败"
						});
						return
					}
					self.balanceAmount = result.data.balanceAmount
					self.itemData = []
					self.paymentTotal = 0
					self.unpaidTotal = 0
					self.totalDiscount = 0
					self.totalAmount = 0
					result.data.group.forEach((item, index1) => {
						item.lists.forEach((item2, index2) => {
							if (item2.listType != '销售退货单' && item2.listType != '其它退款单') {
								self.paymentTotal += item2.paymentAmount
							}
							self.unpaidTotal += item2.unpaidAmount
							self.totalDiscount += item2.discountAmount
							self.totalAmount += item2.amount
							if (index1 == 0 && index2 == 0) {
								item2.originalPrice = formatNum(self.balanceAmount + item2
									.unpaidAmount)
							} else {
								if (index2 == 0) {
									item2.originalPrice = formatNum(result.data.group[index1 - 1]
										.lists[result.data.group[index1 - 1].lists.length - 1]
										.originalPrice + item2.unpaidAmount)
								} else {
									item2.originalPrice = formatNum(result.data.group[index1]
										.lists[index2 - 1].originalPrice + item2.unpaidAmount)
								}
							}
							self.itemData.push(item2)
						});
					});
					self.paymentTotal = formatNum(self.paymentTotal)
					self.unpaidTotal = formatNum(self.unpaidTotal)
					self.totalDiscount = formatNum(self.totalDiscount)
					self.totalAmount = formatNum(self.totalAmount)
					self.finalTotal = formatNum(self.unpaidTotal + self.balanceAmount)
				}).catch(err => {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "获取对账单失败"
					});
				})
			},
			getReconciliationList(innerHtml) {
				this.currentDate = innerHtml
				let self = this;
				switch (innerHtml) {
					case '昨日':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.startTime(dateUtil.getYesterday()));
						self.searchItems.totalBusinessDate.push(dateUtil.endTime(dateUtil.getYesterday()));
						break;
					case '本周':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getBeginWeek().replace(" 00:00:00", ""));
						self.searchItems.totalBusinessDate.push(dateUtil.getEndWeek().replace(" 23:59:59", ""));
						break;
					case '本月':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getBeginMonth().replace(" 00:00:00", ""));
						self.searchItems.totalBusinessDate.push(dateUtil.getEndMonth().replace(" 23:59:59", ""));
						break;
					case '本年':
						self.searchItems.totalBusinessDate = [];
						self.searchItems.totalBusinessDate.push(dateUtil.getCurrentYearStartDate().replace(" 00:00:00",
							""));
						self.searchItems.totalBusinessDate.push(dateUtil.getCurrentYearEndDate().replace(" 23:59:59", ""));
						break;
					default:
						this.openPicker();
						return;
				}
				this.initItemData();
			},
			pickerChange(val) {
				if (val[0] && val[1]) {
					this.searchItems.totalBusinessDate = [];
					this.searchItems.totalBusinessDate.push(dateUtil.startTime(val[0]).replace(" 00:00:00", ""));
					this.searchItems.totalBusinessDate.push(dateUtil.endTime(val[1]).replace(" 23:59:59", ""));
					this.initItemData();
				}
			},
			pickerClear(val) {
				this.pickerStatus = false;
			},
			pickerOk(val) {
				this.pickerStatus = false;
			},
			openPicker(val) {
				this.pickerStatus = false;
				let self = this
				setTimeout(function() {
					self.pickerStatus = true;
				}, 300)
			},
			initCustomerSelect() {
				let self = this;
				request.get('/api/Customer/GetCustomerToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取客户数据失败：" + response.errorMsg
						});
						return;
					}
					self.customerList = response.data;
				}).catch(function(error) {})
			},
			selectChange() {
				this.initItemData();
			},
			goList(param) {
				switch (param.listType) {
					case '销售订单':
						this.$router.push({
							path: 'salesplanlistdetail',
							query: {
								planListId: param.id
							}
						});
						break
					case '销售单':
						this.$router.push({
							path: 'saleslistdetail',
							query: {
								salesListId: param.id
							}
						});
						break
					case '其它付款单':
						this.$router.push({
							path: 'othercostlistdetail',
							query: {
								otherCostListId: param.id
							}
						});
						break
					case '其它收款单':
						this.$router.push({
							path: 'otherreceiptlistdetail',
							query: {
								otherReceiptListId: param.id
							}
						});
						break
					case '销售退货单':
						this.$router.push({
							path: 'returnsaleslistdetail',
							query: {
								returnSalesListId: param.id
							}
						});
						break
					case '付款单':
						this.$router.push({
							path: 'paymentlistdetail',
							query: {
								paymentListId: param.id
							}
						});
						break
					case '收款单':
						this.$router.push({
							path: 'receiptlistdetail',
							query: {
								receiptListId: param.id
							}
						});
						break
				}
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['CustomerReconciliationList.Show'],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					}else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
						self.$Modal.warning({
							title:'系统到期提示',
							content: response.errorMsg,
							onOk:() => {
								localStorage.setItem("_tipTimeoutCount",1);
							}
						});
					}
					if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
						localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'CustomerReconciliationList.Show':
								self.permission.isShow = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			}
		},
		watch: {},
		created: function() {
			this.initPermission();
			this.initCustomerSelect();
			this.initItemData();
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.amount-box {
		background-color: white;
		padding: 30px;
	}

	.amount-box-title {
		margin-left: 5px;
		font-size: 14px;
		text-align: left;
		color: rgb(204, 215, 220);
	}

	.amount-box-amount {
		font-size: 30px;
		text-align: left;
	}

	.amount-box-percentage {
		font-size: 20px;
		text-align: center;
	}

	.amount-box-desc {
		text-align: center;
		color: rgb(204, 215, 220);
	}

	.uni-row {
		overflow: hidden;
	}

	.flex-item-20 {
		float: left;
		width: 20%;
		text-align: center;
		padding: 5px;
		cursor: pointer;
	}

	.head-1 {
		background-color: #fff;
		color: #000;
		border-radius: 5px 5px 0px 0px;
		border-bottom: 2px solid #ff6a7f;
	}

	.head-2 {
		background-color: #fff;
		color: #000;
		border-radius: 5px;
		overflow: hidden;
		text-align: center;
		padding: 5px;
	}

	.flex-item-50 {
		float: left;
		width: 50%;
		text-align: center;
		padding: 5px;
	}

	.flex-item-60 {
		float: left;
		width: 60%;
		text-align: center;
		padding: 5px;
	}

	.head-2-left {
		float: left;
		height: 32px;
		line-height: 32px;
	}

	.head-2-right {
		float: right;
		height: 32px;
		line-height: 32px;
	}

	.head-2-center {
		display: inline-block;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}
</style>